<div [attr.data-automation]="config.dataAutomation">
  <div class="row">
    <div class="col-12">
      <legend>{{ getLabel() | translate }}</legend>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      @if (isNoNumbersRemaining) {
        <div data-automation="extension-selector-no-remaining-alert" class="alert alert-warning">
          {{ 'tkey;dndidselection.nomoredns' | translate }}
        </div>
      }
      @if (filteredOptions.length === 0 && !isNoNumbersRemaining) {
        <div data-automation="extension-selector-no-matches-alert" class="alert alert-warning">
          {{ 'tkey;dnselection.no_matches' | translate }}
        </div>
      }
      @if (!!validationMessage?.content && showValidation) {
        <div data-automation="extension-selector-validation" class="alert alert-danger">
          <span [innerHTML]="validationMessage.content | escapeHtml: validationMessage?.params"></span>
          @if (!!usageLocationProps() && !usageLocationProps().valid && !!this.fieldData) {
            <ziro-button
              [dataAutomation]="'usage-location-fix-it-button'"
              [buttonStyle]="buttonStyles.LINK"
              (clicked)="openUsageLocationModal()"
              [label]="'tkey;microsoft_360.view.teams.extensionSelection.number_usage_location.fix_it.label'"
              [labelCssClass]="'strong'"
            ></ziro-button>
          }
        </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ziro-filter-input
        (filterChanged)="onFilterChanged($event)"
        [placeholder]="'tkey;shared.extensionSelector.filter.placeholder'"
        [dataAutomation]="'extension-selector-filter-input'"
        [isDisabled]="isSubmitting()"
      ></ziro-filter-input>
    </div>
  </div>

  <div class="row my-3 extension-row">
    <input [type]="'hidden'" [(ngModel)]="fieldData" [attr.data-automation]="config.dataAutomation + '-hidden-input'" />

    <ng-template #tipContent let-option="option">
      <span
        [innerHtml]="(option?.tooltip ? (option.tooltip.message | translate: option.tooltip?.params) : '') | escapeHtml"
      ></span>
    </ng-template>

    @for (option of displayedFilteredOptions; track option; let i = $index) {
      <div
        class="extension-cell"
        [ngClass]="{
          'col-md-4 col-lg-2 col-sm-4': size === ExtensionSelectorSize.LARGE,
          'col-md-6 col-lg-4 col-sm-4': size === ExtensionSelectorSize.SMALL,
        }"
        [attr.data-automation]="'extension-selector-option'"
        [ngbTooltip]="tipContent"
        [tooltipContext]="{ option }"
        [triggers]="'hover'"
        [container]="'body'"
        [disableTooltip]="!option.tooltip"
      >
        <button
          type="button"
          [ngClass]="{
            'btn-dark animate__animated animate__bounceIn animate__faster': option.value === fieldData,
            'btn-outline-default': option.value !== fieldData,
            'btn-outline-danger':
              option.assignmentStatus === DialPlanGroupEntryStatus.ASSIGNED ||
              option.assignmentStatus === DialPlanGroupEntryStatus.RESTRICTED ||
              option.assignmentStatus === DialPlanGroupEntryStatus.TEAMS_UNASSIGNED_NUMBER_ROUTING_RULE ||
              option.isDisabled,
          }"
          [disabled]="
            state.disabled ||
            option.assignmentStatus === DialPlanGroupEntryStatus.ASSIGNED ||
            option.assignmentStatus === DialPlanGroupEntryStatus.RESTRICTED ||
            option.assignmentStatus === DialPlanGroupEntryStatus.TEAMS_UNASSIGNED_NUMBER_ROUTING_RULE ||
            option.isDisabled
          "
          (click)="onOptionSelected(option.value)"
          class="btn btn-border btn-sm"
        >
          <span>
            @if (option.deletionDate) {
              <i [ngClass]="ziroIcons.HISTORY + ' me-1'"></i>
            }
            @if (option.assignmentStatus === DialPlanGroupEntryStatus.INACTIVE) {
              <i [ngClass]="ziroIcons.INACTIVE + ' me-1'"></i>
            }
            @if (
              option.assignmentStatus === DialPlanGroupEntryStatus.ASSIGNED ||
              option.assignmentStatus === DialPlanGroupEntryStatus.RESTRICTED ||
              option.assignmentStatus === DialPlanGroupEntryStatus.TEAMS_UNASSIGNED_NUMBER_ROUTING_RULE ||
              option.isDisabled
            ) {
              <i [ngClass]="ziroIcons.UNAVAILABLE + ' me-1'"></i>
            }
            <span data-automation="extension-selector-option-value">
              {{ option.value | telephoneNumberFilter }}
            </span>
          </span>
        </button>
      </div>
    }
  </div>

  <ziro-pagination
    [(page)]="page"
    [pageSize]="PAGE_SIZE"
    [totalResults]="filteredOptions.length"
    [disabled]="state.disabled"
    [dataAutomation]="'ziro-extension-selector-pagination'"
    (pageChanged)="onPageChange()"
  ></ziro-pagination>
</div>
